import { render, staticRenderFns } from "./DocScanner.vue?vue&type=template&id=1857834b&"
import script from "./DocScanner.vue?vue&type=script&lang=js&"
export * from "./DocScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports